import React from 'react';

interface Props {
  tabNames: string[];
  onChange: (clickedTab: string) => void;
  defaultTab?: string;
  selectedTab: string;
  selectedIndex: number;
}

interface State {
  activeTab: string;
}

class Tabs extends React.Component<Props, State> {
  static defaultProps = {
    tabNames: [],
    onChange: (): void => {},
    selectedIndex: 0,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      activeTab: '',
    };
  }

  handleTabClick = (clickedTab: string): void => {
    const currentTab = this.state.activeTab;

    if (clickedTab !== currentTab) {
      this.setState({ activeTab: clickedTab });

      this.props.onChange(clickedTab);
    }
  };

  componentDidMount = (): void => {
    const { selectedTab } = this.props;
    const currentTab = this.state.activeTab;

    if (selectedTab !== currentTab) {
      this.setState({ activeTab: selectedTab });
    }
  };

  componentDidUpdate = (): void => {
    const { selectedTab } = this.props;
    const currentTab = this.state.activeTab;

    if (selectedTab !== currentTab) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ activeTab: selectedTab });
    }
  };

  render(): React.ReactNode {
    const { activeTab } = this.state;

    const children = React.Children.map(this.props.children, (child, index) => {
      if (React.isValidElement(child)) {
        const isSelected = activeTab === child.props.name;
        return React.cloneElement(child, {
          onClick: this.handleTabClick,
          selected: isSelected,
          index,
        });
      }
    });

    return (
      <div
        className="w100 row bb-solid b-width-2"
        style={{ borderBottomColor: '#e6e6e6' }}
      >
        {children}
      </div>
    );
  }
}

export default Tabs;
